// MemberCheckIn.js
import React, { useState } from "react";
import axios from "axios";
import "./MemberCheckIn.css";

const MemberCheckIn = ({ bookingId, appointmentDate, onCheckInSuccess }) => {
  const token = localStorage.getItem("jwtToken");
  const [checkedIn, setCheckedIn] = useState(false);
  const [checkInMessage, setCheckInMessage] = useState("");
  const now = new Date();
  const appt = new Date(appointmentDate);
  // Calculate the allowed check-in time: 15 minutes before the appointment
  const allowedCheckInTime = new Date(appt.getTime() - 15 * 60000);
  //const allowedCheckInTime = now; /* For Testing Purposes */

  // If already checked in, don't render the button
  if (checkedIn) {
    return (
      <p className="checkin-message">You have checked in to this session.</p>
    );
  }

  // If current time is before allowed check-in time, don't render the button but show a message
  if (now < allowedCheckInTime) {
    return (
      <p className="checkin-message">
        Check-in will be available 15 minutes before your session.
      </p>
    );
  }

  const handleCheckIn = async () => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/sessions/checkin`,
        { bookingId },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      alert(response.data.message);
      setCheckedIn(true); // Hide the button upon successful check-in
      setCheckInMessage("You have checked in to this session."); // Show check-in confirmation
      if (onCheckInSuccess) {
        onCheckInSuccess(bookingId, "checked-in"); // Notify parent component
      }
    } catch (error) {
      console.error(
        "Error during check-in:",
        error.response ? error.response.data : error
      );
      alert(error.response?.data?.message || "Error during check-in.");
    }
  };

  return (
    <div>
      <button className="checkin-btn" onClick={handleCheckIn}>
        Check In
      </button>
      {checkInMessage && <p className="checkin-message">{checkInMessage}</p>}
    </div>
  );
};

export default MemberCheckIn;
